import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-help-import-community-programs',
  templateUrl: './help-import-community-programs.component.html',
  styleUrls: ['./help-import-community-programs.component.scss']
})
export class HelpImportCommunityProgramsComponent
{
  @Input() public language: string;

  public sampleFileUrl = 'assets/files/communityServices.csv';
  public document360Url = 'https://channels360.document360.io/docs/community-services-import';
}
